import omit from 'transmute/omit';
const getObjectWithOmittedProps = (source, propOmissionMap = {}) => {
  const unwantedProps = Object.keys(source).filter(prop =>
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  source[prop] === undefined || source[prop] === propOmissionMap[prop]);
  return omit(unwantedProps, source);
};
export default getObjectWithOmittedProps;